import { ControlReferenceMSG as ControlReference } from "../../../../interfaces/controlReference.msg.interface";
/**
 * Enhances content by adding hover-over explanation boxes for each control reference.
 * @param content - The HTML content string containing spans with data-controlref attributes.
 * @param controlReferences - An array of ControlReference objects.
 * @returns The modified content string with hover-over explanations.
 */
export function populateTooltips(content: string, controlReferences: ControlReference[]): string {
    // Create a mapping from ref number to ControlReference for quick lookup
    const refMap: { [key: number]: ControlReference } = {};
    controlReferences.forEach(ref => {
        refMap[ref.ref] = ref;
    });

    // Use a DOM parser to safely manipulate the HTML content
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');

    // Select all spans with data-controlref attribute
    const spans = doc.querySelectorAll('span[data-controlref]');
    console.log('[spans]', spans);

    spans.forEach(span => {
        const refValue = span.getAttribute('data-controlref');
        if (refValue) {
            const refNumber = parseInt(refValue, 10);
            const controlRef = refMap[refNumber];
            if (controlRef) {
                // Option 1: Using the title attribute for simple tooltips
                if (controlRef.text === "") {
                    span.setAttribute('tooltitle', `Framework: ${controlRef.controlID}`);
                } else {
                    span.setAttribute('tooltitle', `Clause ${controlRef.controlID}: ${controlRef.text}`);
                }
                // Optionally, add a class for styling
                span.classList.add('control-ref-tooltip');
            } else {
                console.warn(`No control reference found for ref number: ${refNumber}`);
            }
        }
    });

    // Serialize the modified document back to a string
  console.log('[populateTooltips]', doc.body.innerHTML);
    return doc.body.innerHTML;
}
